/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Locationnote1Inputs */

const en_settings_locationnote1 = /** @type {(inputs: Settings_Locationnote1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location may be approximate`)
};

/**
* | output |
* | --- |
* | "Location may be approximate" |
*
* @param {Settings_Locationnote1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_locationnote1 = /** @type {((inputs?: Settings_Locationnote1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Locationnote1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_locationnote1(inputs)
});
export { settings_locationnote1 as "settings_locationNote" }